import { BaseTLTableComponent, AxiosResponse, tlISODateToLocalString, tlISODateTimeToLocalNoSecondsString, BaseTLTableBase } from "../../../Infrastructure/CorBase/CoreBase";
import { TariffService, TariffFilter } from "../../../Services/AccBase/AllAccServices";

export default abstract class TariffListBase extends BaseTLTableComponent {

	protected tariffService: TariffService = new TariffService();

	callActionClick() {
		this.isBusy = true;
		this.deleteItemsList = this.getSelectedList();
		super.deleteList();
		this.itemsSelected = null;
		(this.$refs.tariffTable as BaseTLTableBase).clearSelected();
	
	}

	

	protected deleteListServer(): Promise<AxiosResponse<any>> {
		return this.tariffService.deleteList(this.deleteItemsList);
	}

	protected contentModal = this.$t('tariff.messageQuestionMain').toString();

	deleteItem = 0;
	protected showAlertBeforeDeleteBase(itemsSelected: any) {	
		this.deleteItem = Number(itemsSelected);	
		this.showAlertBeforeActionClickBase(itemsSelected, this.$t('tariff.messageQuestionMain').toString());		
	}

	protected setFields() {
		this.fields = [
			//{ key: 'id', label: this.$t('tariff.fieldIdentif'), trans: 'tariff.fieldIdentif', sortable: true, class: 'text-center' },
			{ key: 'name', label: this.$t('tariff.fieldName'), trans: 'tariff.fieldName', sortable: true, class: 'text-center' },
			{ key: 'description', label: this.$t('tariff.fieldDescription'), trans: 'tariff.fieldDescription', sortable: true, visible: true, class: 'text-center' },
			{ key: 'pricelistName', label: this.$t('tariff.fieldPricelistName'), trans: 'tariff.fieldPricelistName', sortable: true, class: 'text-center' },
			{ key: 'maturityDay', label: this.$t('tariff.fieldMaturityDay'), trans: 'tariff.fieldMaturityDay', sortable: true, visible: true, class: 'text-center' },
			{ key: 'urgentDay', label: this.$t('tariff.fieldUrgentDay'), trans: 'tariff.fieldUrgentDay', sortable: true, visible: true, class: 'text-center' },
		

			{ key: 'actions', label: this.$t('tariff.fieldAction'), trans: 'tariff.fieldAction', class: 'text-right', thClass: 'lastColumnMichael' }
		]
	};

	protected setfilters(value: any) {
		if (value != null) {
			this.filters = value;
		}
		else {
			this.filters = [
				{ key: 'name', label: this.$t('tariff.fieldName'), trans: 'tariff.fieldName', selected: false, value: null, type: 'text' },
				{ key: 'description', label: this.$t('tariff.fieldDescription'), trans: 'tariff.fieldDescription', selected: false, value: null, type: 'text' },
			];
		}
	}


	protected fetchData() {
		super.fetchData();
	}

	protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
		let tariffFilter: TariffFilter = new TariffFilter(null);
		return this.tariffService.getAllByFilter(tariffFilter);
	}

	//zat�m nepotrebujeme
	fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
		return this.fetchDataFromServer();
	}

	refreshItems(items: any[], refreshData: any[]) {
		return items;
	}


	protected prepareItems(items: any[]) {
	};
}